/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MarketItemShopUpsertRequest model module.
 * @module model/MarketItemShopUpsertRequest
 * @version 1.0
 */
class MarketItemShopUpsertRequest {
    /**
     * Constructs a new <code>MarketItemShopUpsertRequest</code>.
     * @alias module:model/MarketItemShopUpsertRequest
     */
    constructor() { 
        
        MarketItemShopUpsertRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MarketItemShopUpsertRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MarketItemShopUpsertRequest} obj Optional instance to populate.
     * @return {module:model/MarketItemShopUpsertRequest} The populated <code>MarketItemShopUpsertRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MarketItemShopUpsertRequest();

            if (data.hasOwnProperty('dataType')) {
                obj['dataType'] = ApiClient.convertToType(data['dataType'], 'Number');
            }
            if (data.hasOwnProperty('jsonData')) {
                obj['jsonData'] = ApiClient.convertToType(data['jsonData'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MarketItemShopUpsertRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MarketItemShopUpsertRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['jsonData'] && !(typeof data['jsonData'] === 'string' || data['jsonData'] instanceof String)) {
            throw new Error("Expected the field `jsonData` to be a primitive type in the JSON string but got " + data['jsonData']);
        }

        return true;
    }


}



/**
 * @member {Number} dataType
 */
MarketItemShopUpsertRequest.prototype['dataType'] = undefined;

/**
 * @member {String} jsonData
 */
MarketItemShopUpsertRequest.prototype['jsonData'] = undefined;






export default MarketItemShopUpsertRequest;

